import React from 'react';
import { Phone, MessageCircle, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../data/mock';

const StickyMobileCTA = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-white border-t border-gray-200 shadow-lg">
      <div className="flex items-center justify-around py-3 px-2">
        <a
          href={`tel:${siteConfig.contact.phone}`}
          className="flex flex-col items-center gap-1 text-emerald-700 hover:text-emerald-800 transition-colors"
        >
          <div className="bg-emerald-100 p-2 rounded-full">
            <Phone size={20} />
          </div>
          <span className="text-xs font-medium">Appeler</span>
        </a>
        
        <a
          href={`https://wa.me/${siteConfig.contact.whatsapp.replace(/\s/g, '')}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center gap-1 text-emerald-700 hover:text-emerald-800 transition-colors"
        >
          <div className="bg-emerald-100 p-2 rounded-full">
            <MessageCircle size={20} />
          </div>
          <span className="text-xs font-medium">WhatsApp</span>
        </a>
        
        <Link
          to="/devis"
          className="flex flex-col items-center gap-1 text-white"
        >
          <div className="bg-emerald-700 p-2 rounded-full">
            <FileText size={20} />
          </div>
          <span className="text-xs font-medium text-gray-700">Devis</span>
        </Link>
      </div>
    </div>
  );
};

export default StickyMobileCTA;
